import React from 'react'
import { Accordion } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { RestrictedConsignmentItem, RestrictionCheck } from '../../transit-operation/models/types'

interface RestrictionWarningMessageProps {
  check: RestrictionCheck
}

export const hasRestrictionHits = (check: RestrictionCheck) => check.restrictedConsignmentItems.length > 0
  || check.restrictedTraderNames.length > 0
  || check.restrictedTransportMeans.length > 0

const formatConsignmentItem = (item: RestrictedConsignmentItem) => [
  item.declarationGoodsItemNumber !== null ? `#${item.declarationGoodsItemNumber}` : null,
  item.hsCode,
  item.descriptionOfGoods,
].filter(Boolean).join(' ')

function RestrictionWarningMessage({ check }: RestrictionWarningMessageProps) {
  const { t } = useTranslation()

  return (
    <>
      <ul className="mb-3">
        {check.restrictedConsignmentItems.length > 0 && <li>{t('transitOperation.restrictionWarning.restrictedGoods')}</li>}
        {check.restrictedTraderNames.length > 0 && <li>{t('transitOperation.restrictionWarning.restrictedTrader')}</li>}
        {check.restrictedTransportMeans.length > 0 && <li>{t('transitOperation.restrictionWarning.restrictedTruck')}</li>}
      </ul>
      <Accordion>
        <Accordion.Item eventKey="details">
          <Accordion.Header>{t('transitOperation.restrictionWarning.showDetails')}</Accordion.Header>
          <Accordion.Body className="restriction-warning__details">
            {check.restrictedConsignmentItems.length > 0 && (
              <>
                <p className="fw-bold mb-1">{t('transitOperation.restrictionWarning.restrictedGoodsLabel')}</p>
                <ul className="mb-2">
                  {check.restrictedConsignmentItems.map((item, index) => (
                    <li key={item.consignmentItemId ?? index}>{formatConsignmentItem(item)}</li>
                  ))}
                </ul>
              </>
            )}
            {check.restrictedTraderNames.length > 0 && (
              <>
                <p className="fw-bold mb-1">{t('transitOperation.restrictionWarning.restrictedTraderLabel')}</p>
                <ul className="mb-2">
                  {check.restrictedTraderNames.map((name) => <li key={name}>{name}</li>)}
                </ul>
              </>
            )}
            {check.restrictedTransportMeans.length > 0 && (
              <>
                <p className="fw-bold mb-1">{t('transitOperation.restrictionWarning.restrictedTruckLabel')}</p>
                <ul className="mb-0">
                  {check.restrictedTransportMeans.map((number) => <li key={number}>{number}</li>)}
                </ul>
              </>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  )
}

export default RestrictionWarningMessage
